module.exports = __webpack_public_path__ + "affa34f269410b17f04d5caaccb47990.png";